import {remCalc} from '../../_utils'

export default {
    baseStyle: {
        playIcon: {
            height: remCalc(40),
            width: remCalc(40),
            fill: 'background.default',
        },
        playIconContainer: {
            position: 'absolute',
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            width: '100%',
            height: '100%',
            border: 'none',
            cursor: 'pointer',
            top: 0,
            left: 0,
        },
        videoContainer: {
            width: '100%',
            maxWidth: remCalc(1920),
            position: 'relative',
            margin: '0 auto',
            height: {
                base: remCalc(226),
                md: remCalc(478),
                lg: remCalc(608),
                xl: remCalc(1080),
            },
            paddingY: {
                base: remCalc(16),
                md: remCalc(24),
                lg: remCalc(40),
            },
        },
        videoContainerYoutube: {
            width: '100%',
            aspectRatio: '16 / 9',
            maxWidth: remCalc(1920),
            margin: '0 auto',
        },
        video: {
            width: '100%',
            height: '100%',
            objectFit: 'fill',
        },
    },
}
